import { PermissionsList } from '@/helpers/permissions.js';
import { TokenService } from '@/plugins/token-service';

const state = {
  accessToken: TokenService.getToken() || null,
  expiryTokenDate: TokenService.getExpireTokenDate() || null,
  tokenType: 'Bearer',
  user: {
    id: 0,
    email: '',
    full_name: '',
  },
  roles: {},
  permissions: Object.keys(PermissionsList).reduce((result, key) => {
    result[PermissionsList[key]] = false;
    return result;
  }, {}),
};

export default state;
